import { Fragment } from "react"

export const lineBreaksToHtml = (input: string) =>
  input.split('\n').map((item, key) => <Fragment key={key}>{item}<br/></Fragment>)
